<ng-container *transloco="let t">
  <div class="user-facility" *ngIf="authService.authenticated$ | async">
    <span class="label">
      {{ t('core.layout.header.facility') }}
    </span>
    <span class="value" [class.no-change]="(this.authService.chgfacility$ | async) === 'N'" (click)="facilityService.changeFacility()">
      {{ authService.facility$ | async }}
    </span>
  </div>
</ng-container>
